<template>
  <div class="p_clue_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">企业全称</div>
                    <el-input v-model="listQuery.strEntName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <div class="flname">操作人</div>
                    <el-input v-model="listQuery.strgdname" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput screen_btn">
                    <el-button :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-left:5px">搜索</el-button>
                </div>
                <!-- <div class="screenInput">
                  <div class="flname">任务</div>
                  <el-select v-model="listQuery.taskid" size="small" placeholder="" clearable>
                    <el-option v-for="(item,index) in taskList" :key="index+'a'" :label="item.strTaskname" :value="item.taskid"></el-option>
                  </el-select>
                </div> -->
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <!-- <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div> -->
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="来源:">
            <el-select v-model="listQuery.strplatform" size="small" placeholder="" clearable>
              <el-option v-for="(item,index) in platformList" :key="index+'b'" :label="item.strplatform" :value="item.strplatform"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区:" class="th_input_label">
            <el-input v-model="listQuery.strAddr" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="招聘单位类型:">
            <el-select filterable v-model="listQuery.strEnttype" placeholder="" size="small" clearable>
              <el-option v-for="(item,index) in typeList" :key="index+'c'" :label="item.Basname" :value="item.Basname"></el-option>
            </el-select>
          </el-form-item>
          
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
          <el-breadcrumb-item>管理</el-breadcrumb-item>
          <el-breadcrumb-item>流程数据</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box">
        <comTabs ref="child" :active="activeName"></comTabs>
        <div class="report_export_box">
          <el-button v-if="!isNull(tableData)" type="primary" size="small" @click="exportHandle" :loading="btnLoading">导出</el-button>
        </div>
        <el-table ref="clueTable" class="re_table" border v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <el-table-column align="center" label="序号" fixed="left" width="60px" fit :show-overflow-tooltip="true">
              <template slot-scope="{$index}">
                  <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
                </template>
            </el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :fixed="
                item.StrColumId == 'StrEntNice'" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('序号')>-1 ? '60px' : item.StrColumName.indexOf('全称')>-1?('250px'):(item.StrColumName.indexOf('简称')>-1||item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('公海')>-1?'160px':(item.StrColumName.indexOf('缺口')>-1?'72px':'100px'))" align="center"
                >
                <template slot-scope="{row}">
                  <span v-if="item.StrColumId == 'Followstat'">{{row.Followstat == '1'||Number(row.Followstat) > 1?'已跟进':'未跟进'}}</span>
                  <span v-else-if="item.StrColumId == 'Claimstatu'">{{row.Claimstatu == '1'?'已认领':'未认领'}}</span>
                  <span v-else>{{ row[item.StrColumId] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common";
  import comTabs from './components/comTab.vue'
  export default {
    components:{
      comTabs
    },
    data() {
      return {
        activeName:'流程数据',
        tableHeight: 0,
        showDropScreen:-1,
        tableData: [],
        contactsLoading:false,
        listQuery:{
          strEntName:'', //公司名称
          strgdname:'', //操作人
          strTableId:'JBflowpath',
          currpage:1,
          perpage:10
        },
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        tablePath: this.$store.state.EMP.tablePath,
        // 导出参数
        exportQuery:{},
        btnLoading:false
      }
    },
    created() {
      let that = this
      this.calHeight();
      this.tableTitle = [
        {
          StrColumId:'strEntNice',
          StrColumName:'企业全称'
        },
        {
          StrColumId:'strJobName',
          StrColumName:'联系人'
        },
        {
          StrColumId:'strPhone',
          StrColumName:'联系方式'
        },
        {
          StrColumId:'stractMember',
          StrColumName:'操作人'
        },
        {
          StrColumId:'strTime',
          StrColumName:'查看时间'
        },
        {
          StrColumId:'strIsFollow',
          StrColumName:'是否跟进'
        },
        {
          StrColumId:'followTime',
          StrColumName:'跟进时间'
        },
        {
          StrColumId:'followRemark',
          StrColumName:'跟进备注'
        },
        {
          StrColumId:'isCollect',
          StrColumName:'是否认领'
        },
        {
          StrColumId:'collectTime',
          StrColumName:'认领时间'
        }
      ]
      // 从别的页面跳转过来
      if(!that.isNull(that.$route.query.activeName)){
        that.activeName = that.$route.query.activeName
      }
      this.getTableTitle('JBflowpath');
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        // console.log('height', this.tableHeight)
      },
      // 导出
    exportHandle(){
      let that = this
      this.$confirm('是否导出数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((cur) => {
        that.exportQuery = JSON.parse(JSON.stringify(that.listQuery))
        that.exportQuery.currpage = 1
        that.exportQuery.perpage = 10000000
        that.btnLoading = true
        // console.log('tableTitle', that.exportQuery)
        xz.outputReportListNew(that.exportQuery).then((res) => {
          // console.log('tableTitle', res)
          if (res.status == "ok") {
            let path = that.tablePath + res.stroutpath
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
          } else {
            this.$message({
              type: 'error',
              message: '导出失败，请稍后再试'
            })
            return false
          }
          that.btnLoading = false
        });
      })
    },
      // 获取表头
      getTableTitle(strTableId) {
        xz.getEcrmColumnList(strTableId, "").then((res) => {
          // console.log('tableTitle', res)
          if (res.status == "ok") {
            this.tableTitle = res.msg;
            this.getList();
          } else {
            this.tableTitle = [];
          }
        });
      },
      // 获取列表
      getList(){
        this.tableLoading = true
        this.isSearchHandle = true
        xz.getReportprodata(this.listQuery).then(res => {
          // console.log('getList', res)
          if (res.status == 'ok') {
              this.tableData = res.msg
              this.total = Number(res.totalcount)
            }else{
              this.tableData = []
              this.total = 0
            }
          this.tableLoading = false
          this.isSearchHandle = false
        })
      },
      //分页
      handleCurrentChange(val){
          this.listQuery.currpage = Number(val)
          this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.currpage = 1
        this.listQuery.perpage = Number(val)
        this.getList()
      },
      // 搜索
      searchHandle(){
        this.listQuery.currpage = 1
        this.getList()
      },
      // 清空
      resetHandle(){
        this.listQuery = this.$options.data.call(this).listQuery
        this.listQuery.strTableId = 'JBflowpath'
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.j_url_txt{
  text-decoration: underline;
  cursor: pointer;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
.contacts img {
    width: 24px;
    height: 24px;
  }
.report_export_box{
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 10px 0;
  background-color: #fff;
}
</style>
<style>
.p_clue_module .el-table .ascending .sort-caret.ascending{
  border-bottom-color: #C0C4CC;
}
.p_clue_module .el-table .descending .sort-caret.descending{
  border-top-color: #C0C4CC;
}
.p_clue_module .th_input_label .el-form-item__label{
  width: 66px!important;
}
.p_clue_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_clue_module .screenInputs .screenInput .el-select .el-input__inner,
.p_clue_module .re_down_form.el-form--inline .el-form-item__content,
.p_clue_module .re_down_form .el-select,
.p_clue_module .re_down_form .el-form-item__content{
  width: 200px;
}
.p_clue_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_clue_module .screenInputs .screenInput .el-input {
  width: 200px;
}
  .re_table.el-table .cell{
    padding: 0 5px;
  }
  .re_table.el-table .el-table__cell{
    padding: 3px 0;
  }
</style>